var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.modalComponent,_vm._b({ref:"modalRef",tag:"component",attrs:{"is-visible":_vm.isVisible}},'component',_vm.modal.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }